/**
 * Every cached query is namespaced by the signed-in user id so one account can
 * never read another account's cache entry in the same browser tab. This runs
 * centrally through the QueryClient's key hash function, so individual query
 * keys stay short and existing partial-match invalidation keeps working.
 */
let scope = "anon";

export function getQueryScope() {
  return scope;
}

/** Returns true when the scope actually changed (i.e. a different identity). */
export function setQueryScope(userId: string | null | undefined) {
  const next = userId ?? "anon";
  if (next === scope) return false;
  scope = next;
  return true;
}

export function scopedQueryKeyHashFn(queryKey: readonly unknown[]) {
  return JSON.stringify([scope, queryKey], (_, value) =>
    value && typeof value === "object" && !Array.isArray(value)
      ? Object.keys(value)
          .sort()
          .reduce<Record<string, unknown>>((acc, key) => {
            acc[key] = (value as Record<string, unknown>)[key];
            return acc;
          }, {})
      : value,
  );
}
